import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "board-item-scroll-row" }
const _hoisted_2 = ["onClick"]

import { CommonBoardItem } from '@/types/CommonBoardItem'

interface HomeBoardListItemProps {
    itemList: CommonBoardItem[];
}

interface HomeBoardListItemEmits {
    (e: 'on:itemClick', item: CommonBoardItem): void;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'HomeBoardListItem',
  props: {
    itemList: {}
  },
  emits: ["on:itemClick"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emits = __emit

function onItemClick (item: CommonBoardItem) {
  emits('on:itemClick', item)
}


return (_ctx: any,_cache: any) => {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemList, (item) => {
      return (_openBlock(), _createElementBlock("div", {
        key: item.id
      }, [
        _createVNode(_component_v_card, {
          class: "ml-3 mt-2 pa-2 rounded-xl",
          variant: "outlined",
          style: { width: '250px' }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_img, {
                  src: item.image,
                  width: "200px",
                  height: "300px"
                }, null, 8, ["src"]),
                _createElementVNode("div", {
                  class: "item-title",
                  onClick: ($event: any) => (onItemClick(item))
                }, _toDisplayString(item.title), 9, _hoisted_2)
              ]),
              _: 2
            }, 1024),
            _createVNode(_component_v_card_subtitle, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(item.date), 1)
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1024)
      ]))
    }), 128))
  ]))
}
}

})